export default "__VITE_ASSET__154323b6__"